import * as Sentry from '@sentry/browser';
import { ActionKeys } from '~/actions/constants';
import * as pendingInvoiceTransactionsActions from '~/actions/pending-invoice-transactions.actions';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as pendingInvoiceTransactionsService from '~/services/pending-invoice-transactions.service';
import { fromJSON } from '~/types/PendingInvoiceItem';

export function* fetchPendingInvoiceTransactions(
  action: ReturnType<typeof pendingInvoiceTransactionsActions.fetchPendingInvoiceTransactions>,
) {
  try {
    const { pageNumber, pageSize } = action.payload;
    const {
      data: { results, count },
    } = yield call(
      pendingInvoiceTransactionsService.fetchPendingInvoiceTransactions,
      pageNumber,
      pageSize,
    );

    yield put(
      pendingInvoiceTransactionsActions.fetchPendingInvoiceTransactionsSuccess(
        results.map(fromJSON),
        Math.ceil(count / (pageSize || 25)),
      ),
    );
  } catch (e) {
    yield put(pendingInvoiceTransactionsActions.fetchPendingInvoiceTransactionsError(e));
    Sentry.captureException(e);
  }
}

export default [
  takeLatest(ActionKeys.INVOICE_TRANSACTIONS_PENDING_FETCH, fetchPendingInvoiceTransactions),
];
